import { useMemo } from 'react';

import { transformDomainBySubject } from 'src/utils/domains';

type UseDomainDisplayParams = {
  domain: string;
  subject?: string;
};

export const useDomainDisplay = ({
  domain,
  subject,
}: UseDomainDisplayParams): string => {
  return useMemo(() => {
    return transformDomainBySubject(domain, subject);
  }, [domain, subject]);
};
